import { useCallback, useEffect, useState } from "react";
import { deleteData, fetchData, getAccessToken, postData, putData } from "../common/MSALHelper";
import DateTimeInput from "../common/DateTimeInput"
import { useMsal } from "@azure/msal-react";
import { useParams } from "react-router-dom";

export default function ReceiptList({ refresh_toggle}) {
    const { instance, accounts } = useMsal();
    const { member_id } = useParams();
    const [ receiptList, setReceiptList ] = useState([]);
    const [ showAddView, setShowAddView ] = useState(false)

    const getDisplayData = () => {
        // let fields = {
        //     "ReceiptNo": null,
        //     "parishionerID": null,
        //     "IssuedDate": "1900-01-09T00:00:00Z",
        //     "Mark": false,
        //     "amount": 0,
        //     "receiptName": null,
        //     "receiptAddress": null,
        //     "receiptCity": null,
        //     "receiptState": null,
        //     "receiptPostalCode": null,
        //     "receiptCountry": null
        // };

        if (receiptList) {
            if (Array.isArray(receiptList)) {
                const filteredData = receiptList; //data.filter(item => !filterValue || (item["chiHoi"] && item["chiHoi"].toLowerCase().includes(filterValue.toLowerCase())));
                return <table>
                    <thead>
                        <tr>
                            {/* {Object.entries(fields).map(([key, value]) => (<th>{key}</th>))} */}
                            <th>Receipt No</th>
                            <th>Parishioner ID</th>
                            <th>Issued Date</th>
                            <th>Mark</th>
                            <th>Receipt Name</th>
                            <th>Receipt Address</th>
                            <th>Receipt City</th>
                            <th>Receipt State</th>
                            <th>Receipt Postal Code</th>
                            <th>Receipt Country</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map((value) =>
                        (
                            // <tr key={value.ReceiptNo}>
                            //     {Object.entries(fields).map(([key, value2]) => {
                            //         return (
                            //         <td key={`${value.ReceiptNo}-${key}`}>{typeof value[key] === "boolean" ? (value[key] ? 'Yes': 'No') : value[key]}</td>
                            //     )
                            //     })}
                            // </tr>
                            <ReceiptListItem key={value.ReceiptNo} receipt_item={value} refreshData={refresh} />
                        )
                        )
                        }
                    </tbody>
                </table>
            }
            else
                return <div>No data</div>;
        }
        else
            return <div>Loading</div>
    }

    const displayAddView = () => {
        if (showAddView)
            return <AddReceipt member_id={member_id} hideAddView={hideAddView} refreshData={refresh} />
        else
            return <></>
    }

    const hideAddView = () => {
        setShowAddView(false);
    }

    const refresh = () => {
        callFetchData();
    }

    const callFetchData = useCallback(async () => {
        try {
            getAccessToken(instance, accounts).then(response => {
                let accessToken = response;
                fetchData(accessToken, `/users/${member_id}/receipts`, fetch_response => {
                    if (fetch_response.ok)
                        return fetch_response.json();
                    else {
                        console.error('Failed to fetch parishioner data');
                    }
                }, data => {
                    console.log(data);
                    setReceiptList(data);
                    // setFormData({
                    //     ...parishionerData,
                    //     // Convert dates to a format suitable for date input
                    //     hndoG_PLTT_Date: parishionerData.hndoG_PLTT_Date ? new Date(parishionerData.hndoG_PLTT_Date).toISOString().split('T')[0] : '',
                    //     ngayQuaDoi: parishionerData.ngayQuaDoi ? new Date(parishionerData.ngayQuaDoi).toISOString().split('T')[0] : '',
                    //     ngayQuaDoiSecondary: parishionerData.ngayQuaDoiSecondary ? new Date(parishionerData.ngayQuaDoiSecondary).toISOString().split('T')[0] : '',
                    //     registrationDate: parishionerData.registrationDate ? new Date(parishionerData.registrationDate).toISOString().split('T')[0] : ''
                    // });
                });
            });
        } catch (error) {
            console.error('Error fetching parishioner data:', error);
        }
    }, [accounts, instance, member_id]);

    useEffect(() => {
        callFetchData();
    }, [member_id, callFetchData, refresh_toggle]);
    return <div>
        <div><button onClick={() => { setShowAddView(!showAddView) }}>Add Receipt</button></div>
        {displayAddView()}
        <div>
            {getDisplayData()}
        </div>
    </div>;
}

function AddReceipt({hideAddView, refreshData}) {
    const { instance, accounts } = useMsal();
    const { member_id } = useParams();
    // const contribution_id = 0
    const currentDate = new Date();
    const [formData, setFormData] = useState({
        ParishionerID: member_id,
        ReceiptNo: null,
        IssuedDate: currentDate.toISOString().split('T')[0],
        Mark: false,
    });

    const onSubmit = async (event) => {
        event.preventDefault();

        try {
            getAccessToken(instance, accounts).then((response) => {
                let accessToken = response;
                postData(accessToken, `/receipt`, response => {
                    if (response.ok) {
                        // Receipt updated successfully
                        console.log('Receipt updated successfully');
                        hideAddView();
                        refreshData();
                    } else {
                        // Handle error response
                        console.error('Failed to update receipt');
                    }
                }, data => {

                }, JSON.stringify({
                    ...formData,
                }));
            });
        } catch (error) {
            // Handle fetch error
            console.error('Error updating receipt:', error);
        }
    };

    const onCancel = () => {
        hideAddView();
        // refreshData();
    }

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        let newValue = value;

        if (name === 'amount') {
            // Validate amount to allow only numbers with optional decimal point
            newValue = value.replace(/[^0-9.]/g, ''); // Allow only digits and dot
            const decimalCount = (value.match(/\./g) || []).length;
            if (decimalCount > 1 ) {
                // Allow only one decimal point
                newValue = formData.amount;
            }
        } else {
            newValue = type === 'checkbox' ? checked : value;
        }
        setFormData({ ...formData, [name]: newValue });
    };

    /*
    parishionerId: member_id,
        ReceiptNo: null,
        IssuedDate: currentDate.toISOString().split('T')[0],
        Mark: false,
    */

    return <form id="receiptForm" onSubmit={onSubmit}>
        <label htmlFor="ReceiptNo_Display">ID: </label><br />
        <input type="text" id="ReceiptNo" name="ReceiptNo_Display" required readOnly value="(new)" />

        <label htmlFor="IssuedDate">Date:</label><br />
        <input type="date" id="IssuedDate" name="IssuedDate" required onChange={handleChange} value={formData.IssuedDate} /><br />

        <label htmlFor="Mark">Mark:</label><br />
        <input type="checkbox" id="Mark" name="Mark" onChange={handleChange} /><br />

        <button type="submit">Add</button>
        <button onClick={onCancel}>Cancel</button>
    </form>
}

export function ReceiptListItem({ receipt_item, refreshData }) {
    const { instance, accounts } = useMsal();
    // const { filteredData: filteredData } = useParams();
    const [editing, setEditing] = useState(false);
    const [formData, setFormData] = useState({
        ...receipt_item
    });

    const cancel_click = useCallback((event) => {
        setFormData({ ...receipt_item });
        setEditing(false);
    }, [receipt_item]);

    useEffect(() => {
        cancel_click();
    }, [receipt_item, cancel_click])

    const getButtons = function () {
        if (editing) {
            return <>
                <button onClick={() => {
                    submit_click();
                }}>Submit</button>
                <button onClick={(event) => {
                    event.preventDefault();
                    cancel_click();
                }}>Cancel</button>
            </>;
        }
        else {
            return <>
            <button onClick={() => {
                edit_click();
            }
            }>Edit</button>
            <button onClick={() => {
                    delete_click();
            }}>Delete</button>
            </>;
        }
    }

    const edit_click = (event) => {
        setEditing(true);
    }

    const delete_click = async (event) => {
        // Call API to delete
        try {
            getAccessToken(instance, accounts).then(response => {
                let accessToken = response;
                deleteData(accessToken, `/receipt/${receipt_item.ReceiptNo}`, fetch_response => {
                    if (fetch_response.ok) {
                        // Receipt deleted successfully
                        console.log('Receipt deleted successfully');
                        refreshData();
                        setEditing(false);
                    }
                    else {
                        // Handle error response
                        console.error('Failed to delete receipt');
                    }
                }, data => {
                    console.log(data);
                });
            });
        }
        catch (error) {
            // Handle fetch error
            console.error('Error deleting receipt:', error);
        }
    }

    const submit_click = async (event) => {
        //Call API to update
        try {
            getAccessToken(instance, accounts).then(response => {
                let accessToken = response;
                putData(accessToken, `/receipt/${receipt_item.ReceiptNo}`, fetch_response => {
                    if (fetch_response.ok) {
                        // Receipt updated successfully
                        console.log('Receipt updated successfully');
                        refreshData();
                        setEditing(false);
                    }
                    else {
                        // Handle error response
                        console.error('Failed to update receipt');
                    }
                }, data => {
                    console.log(data);
                }, JSON.stringify({
                    ...formData,
                }));
            });
        } catch (error) {
            // Handle fetch error
            console.error('Error updating receipt:', error);
        }
    }

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        let newValue = value;

        if (name === 'amount') {
            // Validate amount to allow only numbers with optional decimal point
            newValue = value.replace(/[^0-9.]/g, ''); // Allow only digits and dot
            const decimalCount = (value.match(/\./g) || []).length;
            if (decimalCount > 1 ) {
                // Allow only one decimal point
                newValue = formData.amount;
            }
        } else {
            newValue = type === 'checkbox' ? checked : value;
        }
        setFormData({ ...formData, [name]: newValue });
    }

    const handleDateChange = (newDateTime) => {
        setFormData({ ...formData, IssuedDate: newDateTime });
    }

    function GetDisplay() {
        return <>
            {
                Object.entries(formData).map(([key, value2]) => {
                    if (editing) {
                        if (["ReceiptNo", "ParishionerID", "Amount", "ReceiptName", "ReceiptAddress", "ReceiptCity", "ReceiptState", "ReceiptPostalCode", "ReceiptCountry"].includes(key)) {
                            return (
                                <td key={`${formData.ReceiptNo}-${key}`}>{typeof formData[key] === "boolean" ? (formData[key] ? 'Yes' : 'No') : formData[key]}</td>
                            )
                        }
                        else if (["Mark"].includes(key)) {
                            return (
                                <td key={`${formData.ReceiptNo}-${key}`}>
                                    <input type="checkbox" name={key} checked={formData[key]} onChange={handleChange} />
                                </td>
                            )
                        }
                        else if (["IssuedDate"].includes(key)) {
                            return (
                                <td key={`${formData.ReceiptNo}-${key}`}>
                                    {/* <input type="datetime-local" name={key} value={new Date(formData[key])} onChange={handleChange} /> */}
                                    <DateTimeInput apiDate={formData[key]} onChange={handleDateChange} />
                                </td>
                            )
                        }
                        else {
                            return (
                                <td key={`${formData.ReceiptNo}-${key}`}>
                                    <input type="text" name={key} value={typeof formData[key] === "boolean" ? (formData[key] ? 'Yes' : 'No') : formData[key]} onChange={handleChange} />
                                </td>
                            )
                        }
                    }
                    else
                        return (
                            <td key={`${formData.ReceiptNo}-${key}`}>{typeof formData[key] === "boolean" ? (formData[key] ? 'Yes' : 'No') : formData[key]}</td>
                        )
                })
            }
        </>
    }

    return <tr key={receipt_item.ReceiptNo}>
        {GetDisplay()}

        <td>{getButtons()}</td>
    </tr>
}